import React, {Component} from 'react';
import { connect } from 'react-redux';
import Title from '../base/title';
import Cta from '../base/cta';
import Modal from '../base/modal';
import moment from 'moment';
import api from '../../utils/api';
import {DrawingManager, GoogleMap, MarkerClusterer, Marker, Polygon, StyledMapWithAnInfoBox, Wkt} from '../base/map';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {helpers} from "../../utils/helpers";

const defaultInactive = {
  SHELL: [],
  PETROBRAS: [],
  YPF: [],
  AXION: [],
  OTRAS: [],
};

const defaultTabs = {
  SHELL: {
    active: true,
    items: [], 
  },
  PETROBRAS: {
    active: false,
    items: []
  },
  YPF: {
    active: false,
    items: [], 
  },
  AXION: {
    active: false,
    items: [], 
  },
  OTRAS: {
    active: false,
    items: [], 
  }
};

class Edit extends Component {

  constructor(props) {
    super(props);

    let _user = this.props.user;

    let allowedGroups = [helpers.groups.ADMINISTRATOR, helpers.groups.PRICING_STAFF];
    let canEditMaster = helpers.checkUserGroup(allowedGroups, _user);

    this.state = {
      loader: ' loader-box',
      created: 'Creado el ' + moment(this.props.data.created).format('DD MMM YYYY'),
      updated: 'Ultima edición ' + moment(this.props.data.modified).format('DD MMM YYYY'),
      name: this.props.data.name,
      master: this.props.data.is_public,
      favourite: this.props.data.is_core,
      inactiveItems: JSON.parse(JSON.stringify(defaultInactive)), 
      currentItem: {},
      currentKey: '',
      markers: [],
      polygons: [],
      modalVisible: false,
      polygon: this.props.data.polygon,
      loadMap: false,
      tabs: JSON.parse(JSON.stringify(defaultTabs)),
      editpolygon: false,
      canEditMaster
    };

    if(_user){
      if(_user.canModifyPublic && !_user.canModifyPrivate){
        this.state.master = true;
      }
    }

    this.getFlag = this.getFlag.bind(this);
    this.setActiveTab = this.setActiveTab.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.removeItemAsk = this.removeItemAsk.bind(this);
    this.addItem = this.addItem.bind(this);
    this.save = this.save.bind(this);
    this.cancel = this.cancel.bind(this);
    this.refreshStations = this.refreshStations.bind(this);
    this.getMarkers = this.getMarkers.bind(this);
    this.removePolygon = this.removePolygon.bind(this);
    this.mapRender = this.mapRender.bind(this);
    this.checkCluster = this.checkCluster.bind(this);
    this.getTabs = this.getTabs.bind(this);
  }

  mapRender(props) {
    let polygon = [];
    if (props.polygon) {
      let wkt = new Wkt.Wkt();
      wkt.read(props.polygon.split(';')[1]);
      wkt.toJson().coordinates[0][0].forEach(cord => {
        polygon.push({ lat: cord[1], lng: cord[0] });
      });
    }
    if (props.loadMap && props.isNew) {
      return <GoogleMap defaultOptions={{ styles: props.myStyle }} defaultZoom={props.zoom} defaultCenter={{ lat: props.bocas['SHELL'].items.length ? parseFloat(props.bocas['SHELL'].items[0].latitude) : props.center.lat, lng: props.bocas['SHELL'].items.length ? parseFloat(props.bocas['SHELL'].items[0].longitude)  : props.center.lng }}>
        <DrawingManager
          onPolygonComplete={function(polygon) { 
            props.checkCluster(api.pathToWkt(polygon.getPath(), props.id, true)); 
            polygon.setMap(null);
          }}
          defaultDrawingMode={'polygon'}
          defaultOptions={{
            drawingControl: true,
            drawingControlOptions: {
              drawingModes: ['polygon'],
            },
            polygonOptions: {
              fillColor: '#005092',
              fillOpacity: 1,
              strokeColor: '#005092',
              strokeWeight: 4,
              clickable: false,
              editable: true,
              zIndex: 1,
            },
          }}
        />
        {props.polygons}
        {props.markers && props.markers.length && <MarkerClusterer averageCenter enableRetinaIcons gridSize={60}>
          {props.markers}
        </MarkerClusterer>}
      </GoogleMap>
    } else if (props.loadMap) {
      return <GoogleMap defaultOptions={{ styles: props.myStyle }} defaultZoom={props.zoom} defaultCenter={{ lat: props.bocas['SHELL'].items.length ? parseFloat(props.bocas['SHELL'].items[0].latitude) : props.center.lat, lng: props.bocas['SHELL'].items.length ? parseFloat(props.bocas['SHELL'].items[0].longitude)  : props.center.lng }}>
        {props.polygon && <Polygon options={{
              fillColor: '#005092',
              fillOpacity: .3,
              strokeColor: '#005092',
              strokeWeight: 4,
              clickable: false,
              //editable: true,
              zIndex: 1,
            }} path={polygon} editable={props.editpolygon} onMouseUp={function(event) { props.checkCluster(api.pathToWkt(this.getPath(), props.id)); }} />}
        {props.polygons}
        {props.markers && props.markers.length && <MarkerClusterer averageCenter enableRetinaIcons gridSize={60}>
          {props.markers}
        </MarkerClusterer>}
      </GoogleMap>
    } else {
      return <div></div>
    }
  }

  checkCluster(polygon) {
    let _self = this;
    this.setState({
      polygon: polygon
    }, function() {
      api.post('helpers/polygon/stations/', { 
        polygon: polygon,
        cluster_edit_id: this.props.data.id
      }).then(resp => {
        if (resp.data.collapse_with_public) toast.error('El cluster se superpone con un cluster público');
        else {
          let tabs = _self.getTabs(resp.data.stations);
          _self.setState({
            inactiveItems: tabs.inactiveItems, 
            tabs: tabs.activeItems
          });
        }
      });
    });
  }

  getTabs(stations) {
    let inactiveItems = JSON.parse(JSON.stringify(defaultInactive));
    let tabs = JSON.parse(JSON.stringify(defaultTabs));

    stations.forEach(station => {
      let key = 'OTRAS';
      if (station.brand.name.indexOf('SHELL') >= 0) key = 'SHELL';
      else if (station.brand.name.indexOf('YPF') >= 0) key = 'YPF';
      else if (station.brand.name.indexOf('AXION') >= 0) key = 'AXION';
      else if (station.brand.name.indexOf('PETROBRAS') >= 0) key = 'PETROBRAS';

      if (station.active) tabs[key].items.push(station);
      else inactiveItems[key].push(station);
    });
    return {
      inactiveItems: inactiveItems, 
      activeItems: tabs
    }
  }

  refreshStations(polygon) {
    let _self = this;
    this.setState({
      polygon: polygon,
      loader: ' loader-box'/*,
      loadMap: false*/
    }, function() {
      api.post('helpers/polygon/stations/', { 
        polygon: polygon,
        cluster_edit_id: this.props.data.id
      }).then(resp => {
        let tabs = _self.getTabs(resp.data.stations);
        _self.getMarkers().then(obj => {
          _self.setState({
            inactiveItems: tabs.inactiveItems, 
            tabs: tabs.activeItems,
            loadMap: true,
            polygon: polygon,
            polygons: obj.p,
            markers: obj.m,
            loader: ''
          }, function() {
            if (resp.data.collapse_with_public) toast.error('El cluster se superpone con un cluster público');
          });
        })
      });
    });
  }

  getMarkers() {
    let _self = this;
    return new Promise( (accept, reject) => {
      /*if (_self.state.markers.length) {
        accept({m: _self.state.markers, p: _self.state.polygons});
        return;
      }*/
      let markers = [];
      let polygons = [];
      api.get('filters/brands').then(resp => {
        let brands = [];
        resp.data.forEach(brand => {
          brands.push('brand_list=' + brand.id);
        });
        api.get('map/?' + brands.join('&')).then(resp => {
          resp.data.stations.map((station,index) => {
            return markers.push(<Marker key={index} icon={{url: api.marker(station.brand.map_marker)}} position={{lat: parseFloat(station.latitude), lng: parseFloat(station.longitude)}}></Marker>);
          });
          resp.data.clusters.map((cluster, index) => {
            if (cluster.id === _self.props.data.id) return true;
            let polygon = [];
            if (cluster.polygon) {
              let wkt = new Wkt.Wkt();
              wkt.read(cluster.polygon.split(';')[1]);
              wkt.toJson().coordinates[0][0].forEach(cord => {
                polygon.push({ lat: cord[1], lng: cord[0] });
              });
            }

            return polygons.push(<Polygon defaultOptions={{
              fillColor: cluster.is_public ? '#666666' : '#CCCCCC',
              fillOpacity: .3,
              strokeColor: cluster.is_public ? '#666666' : '#CCCCCC',
              strokeWeight: 4,
              clickable: false,
              editable: false,
              zIndex: 1,
            }}  key={cluster.id} path={polygon} />);
          });
          accept({m: markers, p: polygons});
          return true;
        });
      });
    });
  }

  componentDidMount() {
    let _self = this;
    if (this.props.data.polygon) {
      this.refreshStations(this.props.data.polygon);
    } else {
      _self.getMarkers().then(obj => {
        _self.setState({
          polygons: obj.p,
          markers: obj.m,
          loadMap: true,
          loader: ''
        });
      })
    }
  }

  save() {
    let _self = this;
    let excluded = [];
    Object.keys(this.state.inactiveItems).forEach(key => {
      _self.state.inactiveItems[key].forEach(station => {
        excluded.push(station.id);
      });
    });

    let data = {
      name: this.state.name,
      is_public: this.state.master,
      is_core: this.state.favourite,
      polygon: this.state.polygon,
      excluded_stations: excluded
    };
    if (this.props.data.id) {
      api.put('clusters/id/' + this.props.data.id + '/', data).then(resp => {
        toast.success('Cambio realizado con éxito!');
        setTimeout(function() {
          window.location.reload();
        }, 2000);
      })
    } else {
      api.post('clusters', data).then(resp => {
        toast.success('Cambio realizado con éxito!');
        setTimeout(function() {
          window.location = '/analisis/cluster/editar/' + resp.data.id;
        }, 2000);
      });
    }
  }

  removePolygon() {
    this.setState({
      polygon: false,
      loadMap: true
    }, function() {
      /*_self.getMarkers().then(obj => {
        _self.setState({
          polygons: obj.p,
          markers: obj.m,
          loadMap: true,
          loader: ''
        });
      })*/
    });
  }

  cancel() {
    this.props.cancel(this.state);
  }

  getFlag(item) {
    this.setState({ flag: item });
  }

  removeItemAsk(key, item) {
    let _self = this;
    this.setState({
      currentKey: key,
      currentItem: item
    }, () => {
      _self.refs.modal.show();
    });
  }

  removeItem() {
    let key = this.state.currentKey;
    let item = this.state.currentItem;
    for (let i = 0; i < this.state.tabs[key].items.length; i++) {
      if (this.state.tabs[key].items[i].id === item.id) {
        this.state.tabs[key].items.splice(i, 1);
        break;
      }
    }
    this.state.inactiveItems[key].push(item);
    this.refs.modal.hide();
    this.setState({
      tabs: this.state.tabs,
      inactiveItems: this.state.inactiveItems
    });
  }

  addItem(key, item) {
    for (let i = 0; i < this.state.inactiveItems[key].length; i++) {
      if (this.state.inactiveItems[key][i].id === item.id) {
        this.state.inactiveItems[key].splice(i, 1);
        break;
      }
    }
    this.state.tabs[key].items.push(item);
    this.setState({
      tabs: this.state.tabs,
      inactiveItems: this.state.inactiveItems
    });
  }

  setActiveTab(key) {
    let keyTabs = Object.keys(this.state.tabs);
    let tabs = this.state.tabs;
    for (let i = 0; i < keyTabs.length; i++) {
      tabs[keyTabs[i]].active = keyTabs[i] === key;  
    }
    this.setState({
      tabs: tabs
    });
  }

  render() {
    let _self = this;
    let _user = _self.props.user;
    let cancel = {
      text: 'CANCELAR', 
      click: () => { 
        _self.setState({
          currentKey: '',
          currentItem: {}
        }, () => {
          _self.refs.modal.hide();
        });
      }
    };
    let save = {
      text: 'CONFIRMAR',
      click: this.removeItem
    }
    return <div className="row edit-cluster">
        <ToastContainer />
        <Modal ref="modal" visible={this.state.modalVisible} save={save} cancel={cancel}>
          <p className="red-text">Al excluir una Estación del cluster, esta será desestimada en los análisis de la herramienta pero seguira formando parte del conjunto del cluster.</p>
          <p>EXCLUIR LA ESTACIÓN</p>
          <p><b>{this.state.currentItem.name}</b></p>
          <p>{this.state.currentItem.address}</p>
        </Modal>
        <div className="row">
          <div className="col s12">
            <div className="row">
              <div className="row edit-cluster-form">
                <div className="col s3">
                  <p>Nombre del cluster</p>
                  <div className="input-container">
                    <input type="text" value={this.state.name} onChange={ ev => { _self.setState({ name: ev.target.value}) }} />
                    <i className="fas fa-pencil-alt"></i>
                  </div>
                </div>
                <div className="col s3">
                  <div className="icon-check-container">
                    <div onClick={() => {
                        if (_user) {
                            if (_user.canModifyPublic && _user.canModifyPrivate) {
                                _self.setState({master: !_self.state.master, favourite: false});
                            }
                        }
                    }} className={'icon-check' + (this.state.master ? ' active' : '') + (!this.state.canEditMaster ? ' hide': '')}>
                      <i className="fas fa-eye"></i>
                      <span>MAESTRO</span>
                    </div>
                    {_self.state.master && <div onClick={() => _self.setState({ favourite: !_self.state.favourite }) } className={'icon-check' + (this.state.favourite ? ' active' : '')}>
                      <i className="fas fa-star"></i>
                      <span>FAVORITO</span>
                    </div>}
                  </div>
                </div>
                <div className="col s6 actions">
                  <div className="col s4">
                    <div className="spans">
                      <span>{this.state.created}</span>
                      <span>{this.state.updated}</span>
                    </div>
                  </div>
                  <div className="col s8">
                    <div className="ctas">
                      <Cta text="DESCARTAR CAMBIOS" light centered className="mr-3" click={this.cancel} />
                      <Cta text="GUARDAR" centered click={this.save} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Title text="EDITAR BOCAS DEL CLUSTER" isGray={true} hasIcon={true} />
        <div className="row">
          <div className="col s12">
            <div className="row">
              <div className="pumps">
                <div className="col s12 no-gutter">
                  {this.state.polygon && <div className="polygon" onClick={() => { _self.setState({ editpolygon: !_self.state.editpolygon, polygon: this.props.data.polygon }) }}>
                    <span>{!_self.state.editpolygon ? 'Editar poligono' : 'Cancelar'}</span>
                    <i className={"fas fa-" + (!_self.state.editpolygon ? 'pencil-alt' : 'times')}></i>
                  </div>}
                  {this.state.polygon && <div className="polygon bottom" onClick={this.removePolygon}>
                    <span>Borrar poligono</span>
                    <i className="fas fa-eraser"></i>
                  </div>}
                  <StyledMapWithAnInfoBox renderMethod={this.mapRender} markers={this.state.markers} isNew={this.state.polygon ? false : true} checkCluster={this.checkCluster} refreshStations={this.refreshStations} loadMap={_self.state.loadMap} id={"4326"} editpolygon={_self.state.editpolygon} bocas={_self.state.tabs} polygon={_self.state.polygon} polygons={_self.state.polygons} />
                  <div className="row">
                    <div className="col s8 no-gutter">
                      <div className="c-tabs">
                        <div className="c-tabs-header">
                         {Object.keys(_self.state.tabs).map(key => {
                            return <div key={key} onClick={() => { _self.setActiveTab(key); }} className={"c-tabs-header-link" + (_self.state.tabs[key].active ? ' active' : '')}>{key} ({_self.state.tabs[key].items.length})</div>
                         })}
                         <div className="c-tabs-header-link last">Excluir</div>
                        </div>
                        <div className="c-tabs-content">
                          {Object.keys(_self.state.tabs).map(key => {
                            return <div key={key} className={"c-tabs-content-item" + (_self.state.tabs[key].active ? ' active' : '')}>
                              <ul className={"pumps-list" + this.state.loader}>
                                {_self.state.tabs[key].items.map(station => 
                                  <li key={station.id}>
                                    <i className={"fas fa-map-marker-alt " + key.toLowerCase()} />
                                    <b>{station.name}</b>
                                    <span>{station.address}</span>
                                    <i onClick={ () => { _self.removeItemAsk(key, station); } } className="fas fa-times"></i>
                                  </li>
                                )}
                              </ul>
                            </div>  
                           })}
                        </div>
                      </div>
                    </div>
                    <div className="col s4 no-gutter">
                      <div className="c-tabs exclude">
                        <div className="c-tabs-header">
                           <div className="c-tabs-header-link first">ESTACIONES EXCLUIDAS</div>
                           <div className="c-tabs-header-link last">Agregar</div>
                         </div>
                         <div className="c-tabs-content">
                          <div className="c-tabs-content-item active">
                            <ul className='pumps-list'>
                              {Object.keys(_self.state.inactiveItems).map(key => {
                                return _self.state.inactiveItems[key].map(station => {
                                  return <li key={station.id}>
                                    <i className={"fas fa-map-marker-alt " + key.toLowerCase()} />
                                    <b>{station.name}</b>
                                    <span>{station.address}</span>
                                    <i onClick={ () => { _self.addItem(key, station); } } className="fas fa-plus"></i>
                                  </li>
                                })
                              })}
                            </ul>
                          </div>  
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  }

}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(Edit);


// WEBPACK FOOTER //
// ./src/containers/analisis/edit.js